import { Alert, AlertTitle, Button, Dialog, DialogActions, DialogContent } from "@mui/material";

interface GuardianRequiredDialogProps {
  open: boolean;
  onClose: () => void;
}

export default function GuardianRequiredDialog({ open, onClose }: GuardianRequiredDialogProps) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" aria-labelledby="legal-guardian-required">
      <DialogContent>
        <Alert severity="error">
          <AlertTitle>The client requires a legal guardian</AlertTitle>
          Please choose at least one team member as the legal guardian of the client
        </Alert>
      </DialogContent>
      <DialogActions>
        <Button color="secondary" onClick={onClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
